import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEc2Status, updateEc2Status } from "../features/ec2DetailSlicer";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function NewNotes() {
  // const [data, SetData]=useState([]);
  const loading = useSelector((state) => state.ec2App.loading);
  const status = useSelector((state) => state.ec2App.status);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tag, setTag] = useState("");
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [isOn, setIsOn] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEc2Status());
  }, []); // Initial load

  useEffect(() => {
    let interval;

    if (status === "pending" || status === "stopping") {
      interval = setInterval(() => {
        dispatch(getEc2Status());
      }, 5000);
    }

    // Clear interval when status changes to something else
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [status]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateEc2Status());
  };

  return (
    <div>
       <button onClick={
        () => {
          sessionStorage.removeItem("token");
          window.location.reload();
        }
      }
      style={{position:"absolute",top:"10px",right:"10px",backgroundColor:"red",color:"white",borderRadius:"5px",border:"none",padding:"10px"}}
        
      >Logout</button>
      <div className="bulb button center">
        <input
          onClick={handleSubmit}
          id="checkbox"
          type="checkbox"
          checked={status == "running" ? true : false}
        />
        <div
          className="button-center center"
          style={{
            color:
              status == "running"
                ? null
                : status == "pending" || status == "stopping"
                ? "red"
                : loading == true
                ? "yellow"
                : "gray",
          }}
        >
          <i className="fa-solid fa-lightbulb"></i>
        </div>
      </div>
      <div className={`status-badge ${status}`}>
        {loading
          ? "🔄 Loading..."
          : status === "running"
          ? "🟢 Running"
          : status === "pending"
          ? "🟡 Pending"
          : status === "stopping"
          ? "🟠 Stopping"
          : status === "stopped"
          ? "🔴 Stopped"
          : "⚪ Unknown"}
      </div>
     
    </div>
  );
}
